import request from '@/utils/request';

/**
 * 商户通过手机号登录
 * @param {*} data 传参
 * @returns {Promise}
 */
export const merchantLogin = data => request({
  url: "/merchant/users/merchantLogin",
  method: 'post',
  data
})

/**
 * 查询认证结果
 * @param {*} data 传参
 * @returns {Promise}
 */
export const authIsSuccess = () => request({
  url: "/merchant/merchant/authIsSuccess",
  method: 'get'
})

/**
 * 发送验证码
 * @param {*} data 传参
 * @returns {Promise}
 */
export const sendSmsByType = data => request({
  url: "/client/user/auth/sendSmsByType",
  method: 'post',
  data
})

/**
 * 上传文件接口
 * @param {*} data 传参
 * @returns {Promise}
 */
export const uploadFile = data => request({
  url: "/merchant/index/uploadImg",
  method: 'post',
  data,
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  timeout: 3 * 60 * 1000
})

/**
 * 商户经营类别列表
 * @param {*} data 传参
 * @returns {Promise}
 */
export const getCompanyBusiness = data => request({
  url: "/merchant/merchant/getCompanyBusiness",
  method: 'post',
  data
})

/**
 * 商户实名认证
 * @param {*} data 传参
 * @returns {Promise}
 */
export const authMerchant = data => request({
  url: "/merchant/merchant/authMerchant",
  method: 'post',
  data
})

/**
 * 商户实名认证失败重新提交
 * @param {*} data 传参
 * @returns {Promise}
 */
export const authMerchantUpd = data => request({
  url: "/merchant/merchant/authMerchantUpd",
  method: 'post',
  data
})

/**
 * 查城市列表
 * @param {*} data 传参
 * @returns {Promise}
 */
export const selectCityList = data => request({
  url: "/client/user/tianmap/selectCityList",
  method: 'post',
  data
})

/**
 * 查城市列表
 * @param {*} data 传参
 * @returns {Promise}
 */
export const nameSearch = data => request({
  url: "/client/user/tianmap/nameSearch",
  method: 'post',
  data
})

/**
 * 查城市列表
 * @param {*} data 传参
 * @returns {Promise}
 */
export const selectProvinceCityDistrict = data => request({
  url: "/client/user/tianmap/selectProvinceCityDistrict",
  method: 'post',
  data
})